export const MeasurementMock = [
  {
    measurementId: 1,
    measurementTypeId: 7656436,
    uomName: "Liter",
    uomCode: "ltr",
    description: "Edible Oils",
  },
  {
    measurementId: 2,
    measurementTypeId: 9876543,
    uomName: "Kilograms",
    uomCode: "KG",
    description: "Millets",
  },
  {
    measurementId: 3,
    measurementTypeId: 9876543,
    uomName: "Pices",
    uomCode: "per",
    description: "Snacks",
  },
];
